export var analytics = function analytics() {
  return typeof window !== 'undefined' && window.analytics;
};
export var chord = function chord() {
  return typeof window !== 'undefined' && window.chord;
};
export var identify = function identify() {
  var a = analytics();
  if (a) {
    a.identify.apply(a, arguments);
  }
  var c = chord();
  if (c) {
    c.identify.apply(c, arguments);
  }
};
/**
 * `getAnonymousId` returns the anonymous ID for the current client's session. This ID should be saved in
 * localStorage. If it doesn't exist, Segment will create a new one.
 */
export var getAnonymousId = function getAnonymousId() {
  var a = analytics() || chord();
  if (!a || !a.user) {
    return undefined;
  }
  var user = a.user();
  if (!user) {
    return undefined;
  }
  if (user.id() !== null) {
    return user.id();
  }
  return user.anonymousId();
};
export var reset = function reset() {
  var a = analytics();
  if (a) {
    a.reset();
  }
  var c = chord();
  if (c) {
    c.reset();
  }
};